
window.addEventListener('load', function() {
	console.log('window load')
	//void window.Ucoast.mediaManager.initialLoad();
});
